export default class ItemInfo {
  id?: string;
  name: string;
  symbol: string;
  description?: string;
  change?: number;
  price?: number;
  changesPercentage?: number;
  createdOn?: Date;
  modifiedOn?: Date;
  refreshNews?: boolean;
  lastRefreshedOnL?: number;
  message?: string;
  needContentRefresh?: boolean;      // Flag to trigger content scraping
  needSentimentRefresh?: boolean;    // Flag to trigger sentiment analysis
  lastHeadlinesFetchedOn?: Date;     // When headlines were last fetched
  lastContentRefreshedOn?: Date;     // When content was last scraped
  constructor(name: string, symbol: string, description: string, id?: string) {
    this.id = id;
    this.name = name;
    this.symbol = symbol;
    this.description = description;
    this.needContentRefresh = false;  // Default to false
    this.needSentimentRefresh = false; // Default to false
  }
}
